export default __webpack_public_path__ + "static/media/NCZimbabwe.910be08d.png";